var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeco9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1710,
    height: 4064,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 51,
    width: 1710,
    height: 4064
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "matrix(1 0 0 1 0 -51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 910.5C-1.2413e-14 856.652 43.6522 813 97.4999 813 151.348 813 195 856.652 195 910.5 195 964.348 151.348 1008 97.4999 1008 43.6522 1008-6.20652e-14 964.348 0 910.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 665.5C505 611.652 548.652 568 602.5 568 656.348 568 700 611.652 700 665.5 700 719.348 656.348 763 602.5 763 548.652 763 505 719.348 505 665.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 406.5C1010 352.652 1053.65 309 1107.5 309 1161.35 309 1205 352.652 1205 406.5 1205 460.348 1161.35 504 1107.5 504 1053.65 504 1010 460.348 1010 406.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 148C1515 94.4283 1558.65 50.9999 1612.5 50.9999 1666.35 50.9999 1710 94.4283 1710 148 1710 201.572 1666.35 245 1612.5 245 1558.65 245 1515 201.572 1515 148Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1428.5C-1.2413e-14 1374.65 43.6522 1331 97.4999 1331 151.348 1331 195 1374.65 195 1428.5 195 1482.35 151.348 1526 97.4999 1526 43.6522 1526-6.20652e-14 1482.35 0 1428.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 1183.5C505 1129.65 548.652 1086 602.5 1086 656.348 1086 700 1129.65 700 1183.5 700 1237.35 656.348 1281 602.5 1281 548.652 1281 505 1237.35 505 1183.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 924.5C1010 870.652 1053.65 827 1107.5 827 1161.35 827 1205 870.652 1205 924.5 1205 978.348 1161.35 1022 1107.5 1022 1053.65 1022 1010 978.348 1010 924.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 665.5C1515 611.652 1558.65 568 1612.5 568 1666.35 568 1710 611.652 1710 665.5 1710 719.348 1666.35 763 1612.5 763 1558.65 763 1515 719.348 1515 665.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1946.5C-1.2413e-14 1892.65 43.6522 1849 97.4999 1849 151.348 1849 195 1892.65 195 1946.5 195 2000.35 151.348 2044 97.4999 2044 43.6522 2044-6.20652e-14 2000.35 0 1946.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 1701.5C505 1647.65 548.652 1604 602.5 1604 656.348 1604 700 1647.65 700 1701.5 700 1755.35 656.348 1799 602.5 1799 548.652 1799 505 1755.35 505 1701.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 1442.5C1010 1388.65 1053.65 1345 1107.5 1345 1161.35 1345 1205 1388.65 1205 1442.5 1205 1496.35 1161.35 1540 1107.5 1540 1053.65 1540 1010 1496.35 1010 1442.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 1183.5C1515 1129.65 1558.65 1086 1612.5 1086 1666.35 1086 1710 1129.65 1710 1183.5 1710 1237.35 1666.35 1281 1612.5 1281 1558.65 1281 1515 1237.35 1515 1183.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2464C-1.2413e-14 2410.43 43.6522 2367 97.4999 2367 151.348 2367 195 2410.43 195 2464 195 2517.57 151.348 2561 97.4999 2561 43.6522 2561-6.20652e-14 2517.57 0 2464Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 2219.5C505 2165.65 548.652 2122 602.5 2122 656.348 2122 700 2165.65 700 2219.5 700 2273.35 656.348 2317 602.5 2317 548.652 2317 505 2273.35 505 2219.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 1960.5C1010 1906.65 1053.65 1863 1107.5 1863 1161.35 1863 1205 1906.65 1205 1960.5 1205 2014.35 1161.35 2058 1107.5 2058 1053.65 2058 1010 2014.35 1010 1960.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 1701.5C1515 1647.65 1558.65 1604 1612.5 1604 1666.35 1604 1710 1647.65 1710 1701.5 1710 1755.35 1666.35 1799 1612.5 1799 1558.65 1799 1515 1755.35 1515 1701.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2981.5C-1.2413e-14 2927.65 43.6522 2884 97.4999 2884 151.348 2884 195 2927.65 195 2981.5 195 3035.35 151.348 3079 97.4999 3079 43.6522 3079-6.20652e-14 3035.35 0 2981.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 2737.5C505 2683.65 548.652 2640 602.5 2640 656.348 2640 700 2683.65 700 2737.5 700 2791.35 656.348 2835 602.5 2835 548.652 2835 505 2791.35 505 2737.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 2478.5C1010 2424.65 1053.65 2381 1107.5 2381 1161.35 2381 1205 2424.65 1205 2478.5 1205 2532.35 1161.35 2576 1107.5 2576 1053.65 2576 1010 2532.35 1010 2478.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 2219.5C1515 2165.65 1558.65 2122 1612.5 2122 1666.35 2122 1710 2165.65 1710 2219.5 1710 2273.35 1666.35 2317 1612.5 2317 1558.65 2317 1515 2273.35 1515 2219.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3499.5C-1.2413e-14 3445.65 43.6522 3402 97.4999 3402 151.348 3402 195 3445.65 195 3499.5 195 3553.35 151.348 3597 97.4999 3597 43.6522 3597-6.20652e-14 3553.35 0 3499.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 3254.5C505 3200.65 548.652 3157 602.5 3157 656.348 3157 700 3200.65 700 3254.5 700 3308.35 656.348 3352 602.5 3352 548.652 3352 505 3308.35 505 3254.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 2996C1010 2942.43 1053.65 2899 1107.5 2899 1161.35 2899 1205 2942.43 1205 2996 1205 3049.57 1161.35 3093 1107.5 3093 1053.65 3093 1010 3049.57 1010 2996Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 2737.5C1515 2683.65 1558.65 2640 1612.5 2640 1666.35 2640 1710 2683.65 1710 2737.5 1710 2791.35 1666.35 2835 1612.5 2835 1558.65 2835 1515 2791.35 1515 2737.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4017.5C-1.2413e-14 3963.65 43.6522 3920 97.4999 3920 151.348 3920 195 3963.65 195 4017.5 195 4071.35 151.348 4115 97.4999 4115 43.6522 4115-6.20652e-14 4071.35 0 4017.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 3772.5C505 3718.65 548.652 3675 602.5 3675 656.348 3675 700 3718.65 700 3772.5 700 3826.35 656.348 3870 602.5 3870 548.652 3870 505 3826.35 505 3772.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 3513.5C1010 3459.65 1053.65 3416 1107.5 3416 1161.35 3416 1205 3459.65 1205 3513.5 1205 3567.35 1161.35 3611 1107.5 3611 1053.65 3611 1010 3567.35 1010 3513.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 3254.5C1515 3200.65 1558.65 3157 1612.5 3157 1666.35 3157 1710 3200.65 1710 3254.5 1710 3308.35 1666.35 3352 1612.5 3352 1558.65 3352 1515 3308.35 1515 3254.5Z",
    fill: "#FF0000",
    fillRule: "evenodd",
    fillOpacity: 0.0509804
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco9);
export default __webpack_public_path__ + "static/media/deco9.86237885de6229a4ccab2d9b052b5b84.svg";
export { ForwardRef as ReactComponent };